import { Control, FieldValues, UseFormWatch } from "react-hook-form";

export interface IComponentListFields{
  data: Array<Object>;
  clickField: (id: number, code: string, description: string, periodType: IPeriodType, periods: number) => void;
  selectedIndicator: number;
  showOnlyDescription?: boolean;
}

export interface IItemList{
  data: any;
  fieldsName: string;
  index: number;
  control: Control<FieldValues>;
  register: (RegisterOptions?: any) => void;
  watch: UseFormWatch<FieldValues>;
  clickField: (id: number, code: string, description: string, periodType: IPeriodType, periods: number) => void;
  selected: boolean;
  showOnlyDescription?: boolean;
}


export enum IPeriodType{
  CURRENT = "1",
  BACK = "2",
  FORWARD = "3",
}
